// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.IsrwafSAp4icb7BK9yvQ {
  border-radius: var(--list-border-radius);
  transition: all 0.2s ease-in-out;
  /* Размеры */
}
.IsrwafSAp4icb7BK9yvQ.LYyhGKd5BbyHB8VDV0xw {
  --list-item-padding: var(--list-sm-item-padding);
  --list-item-border-radius: var(--list-sm-item-border-radius);
  --list-item-font-size: var(--list-sm-font-size);
}
.IsrwafSAp4icb7BK9yvQ.LYyhGKd5BbyHB8VDV0xw .dx-list-item {
  padding: var(--list-item-padding) !important;
  border-radius: var(--list-item-border-radius) !important;
  font-size: var(--list-item-font-size) !important;
}
.IsrwafSAp4icb7BK9yvQ.LYyhGKd5BbyHB8VDV0xw .dx-list-item .dx-list-item-content {
  padding: 0 !important;
}
.IsrwafSAp4icb7BK9yvQ.pXAdIMko1OePWg6ayWeu {
  --list-item-padding: var(--list-md-item-padding);
  --list-item-border-radius: var(--list-md-item-border-radius);
  --list-item-font-size: var(--list-md-font-size);
}
.IsrwafSAp4icb7BK9yvQ.pXAdIMko1OePWg6ayWeu .dx-list-item {
  padding: var(--list-item-padding) !important;
  border-radius: var(--list-item-border-radius) !important;
  font-size: var(--list-item-font-size) !important;
}
.IsrwafSAp4icb7BK9yvQ.pXAdIMko1OePWg6ayWeu .dx-list-item .dx-list-item-content {
  padding: 0 !important;
}
.IsrwafSAp4icb7BK9yvQ.fXRv7ARnmw1CPPs4hgh9 {
  --list-item-padding: var(--list-lg-item-padding);
  --list-item-border-radius: var(--list-lg-item-border-radius);
  --list-item-font-size: var(--list-lg-font-size);
}
.IsrwafSAp4icb7BK9yvQ.fXRv7ARnmw1CPPs4hgh9 .dx-list-item {
  padding: var(--list-item-padding) !important;
  border-radius: var(--list-item-border-radius) !important;
  font-size: var(--list-item-font-size) !important;
}
.IsrwafSAp4icb7BK9yvQ.fXRv7ARnmw1CPPs4hgh9 .dx-list-item .dx-list-item-content {
  padding: 0 !important;
}
.IsrwafSAp4icb7BK9yvQ {
  /* Варианты */
}
.IsrwafSAp4icb7BK9yvQ.u2TPH5zXh56oLAyRD_gB {
  --list-bg: var(--list-main-bg);
  --list-item-bg: var(--list-main-item-bg);
  --list-item-border: var(--list-main-item-border);
  --list-item-text-color: var(--list-main-item-text-color);
  --list-item-hover-bg: var(--list-main-item-hover-bg);
  --list-item-hover-border: var(--list-main-item-hover-border);
  --list-item-hover-text-color: var(--list-main-item-hover-text-color);
  --list-item-focused-bg: var(--list-main-item-focused-bg);
  --list-item-focused-border: var(--list-main-item-focused-border);
  --list-item-focused-text-color: var(--list-main-item-focused-text-color);
  --list-item-selected-bg: var(--list-main-item-selected-bg);
  --list-item-selected-border: var(--list-main-item-selected-border);
  --list-item-selected-text-color: var(--list-main-item-selected-text-color);
  --list-item-disabled-bg: var(--list-main-item-disabled-bg);
  --list-item-disabled-border: var(--list-main-item-disabled-border);
  --list-item-disabled-text-color: var(--list-main-item-disabled-text-color);
  --list-header-bg: var(--list-main-header-bg);
  --list-header-text: var(--list-main-header-text);
  background-color: var(--list-bg);
  color: var(--list-item-text-color);
}
.IsrwafSAp4icb7BK9yvQ.u2TPH5zXh56oLAyRD_gB .dx-list-item {
  background-color: var(--list-item-bg);
  border: var(--list-item-border);
  color: var(--list-item-text-color);
}
.IsrwafSAp4icb7BK9yvQ.u2TPH5zXh56oLAyRD_gB .dx-list-item:hover, .IsrwafSAp4icb7BK9yvQ.u2TPH5zXh56oLAyRD_gB .dx-list-item.dx-state-hover {
  background-color: var(--list-item-hover-bg) !important;
  border: var(--list-item-hover-border) !important;
  color: var(--list-item-hover-text-color) !important;
}
.IsrwafSAp4icb7BK9yvQ.u2TPH5zXh56oLAyRD_gB .dx-list-item.dx-state-focused {
  background-color: var(--list-item-focused-bg) !important;
  border: var(--list-item-focused-border) !important;
  color: var(--list-item-focused-text-color) !important;
}
.IsrwafSAp4icb7BK9yvQ.u2TPH5zXh56oLAyRD_gB .dx-list-item:has(.dx-list-item-content > [data-active=true]) {
  background-color: var(--list-item-selected-bg) !important;
  border: var(--list-item-selected-border) !important;
  color: var(--list-item-selected-text-color) !important;
  font-weight: 600;
}
.IsrwafSAp4icb7BK9yvQ.u2TPH5zXh56oLAyRD_gB .dx-list-item.dx-state-disabled {
  background-color: var(--list-item-disabled-bg) !important;
  border: var(--list-item-disabled-border) !important;
  color: var(--list-item-disabled-text-color) !important;
  cursor: not-allowed;
}
.IsrwafSAp4icb7BK9yvQ.u2TPH5zXh56oLAyRD_gB .iK_RWjSR00HLSLt25T4F {
  background-color: var(--list-header-bg);
  color: var(--list-header-text);
}
.IsrwafSAp4icb7BK9yvQ {
  /* Элементы списка */
}
.IsrwafSAp4icb7BK9yvQ .iK_RWjSR00HLSLt25T4F {
  padding: var(--list-md-item-padding);
  font-weight: 600;
  border-bottom: var(--list-border-width) solid var(--list-border-color);
}
.IsrwafSAp4icb7BK9yvQ {
  /* Состояния */
}
.IsrwafSAp4icb7BK9yvQ.gHxAq8dkqqNVpSTelnxd {
  border: var(--list-border-width) solid var(--list-border-color);
}
.IsrwafSAp4icb7BK9yvQ.LYVd0t95tKbjXQkq2SUc {
  box-shadow: var(--list-shadow);
}
.IsrwafSAp4icb7BK9yvQ.nJHesRfNJxAtapWLtohw {
  border-radius: var(--list-border-radius);
}`, "",{"version":3,"sources":["webpack://./src/UiKit/Lists/List/List.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AA6EhB;EACE,wCAAA;EACA,gCAAA;EAEA,YAAA;AA5EF;AA6EE;EAjFA,gDAAA;EACA,4DAAA;EACA,+CAAA;AAOF;AALE;EACE,4CAAA;EACA,wDAAA;EACA,gDAAA;AAOJ;AANI;EACE,qBAAA;AAQN;AAoEE;EArFA,gDAAA;EACA,4DAAA;EACA,+CAAA;AAoBF;AAlBE;EACE,4CAAA;EACA,wDAAA;EACA,gDAAA;AAoBJ;AAnBI;EACE,qBAAA;AAqBN;AA2DE;EAzFA,gDAAA;EACA,4DAAA;EACA,+CAAA;AAiCF;AA/BE;EACE,4CAAA;EACA,wDAAA;EACA,gDAAA;AAiCJ;AAhCI;EACE,qBAAA;AAkCN;AAiCA;EAiBE,aAAA;AA/CF;AAgDE;EA/EA,8BAAA;EACA,wCAAA;EACA,gDAAA;EACA,wDAAA;EACA,oDAAA;EACA,4DAAA;EACA,oEAAA;EACA,wDAAA;EACA,gEAAA;EACA,wEAAA;EACA,0DAAA;EACA,kEAAA;EACA,0EAAA;EACA,0DAAA;EACA,kEAAA;EACA,0EAAA;EACA,4CAAA;EACA,gDAAA;EAEA,gCAAA;EACA,kCAAA;AAiCF;AA/BE;EACE,qCAAA;EACA,+BAAA;EACA,kCAAA;AAiCJ;AA/BI;EAEE,sDAAA;EACA,gDAAA;EACA,mDAAA;AAgCN;AA7BI;EACE,wDAAA;EACA,kDAAA;EACA,qDAAA;AA+BN;AA5BI;EACE,yDAAA;EACA,mDAAA;EACA,sDAAA;EACA,gBAAA;AA8BN;AA3BI;EACE,yDAAA;EACA,mDAAA;EACA,sDAAA;EACA,mBAAA;AA6BN;AAzBE;EACE,uCAAA;EACA,8BAAA;AA2BJ;AAvBA;EAsBE,oBAAA;AAIF;AAHE;EACE,oCAAA;EACA,gBAAA;EACA,sEAAA;AAKJ;AA/BA;EA6BE,cAAA;AAKF;AAJE;EACE,+DAAA;AAMJ;AAHE;EACE,8BAAA;AAKJ;AAFE;EACE,wCAAA;AAIJ","sourcesContent":["@mixin list-size($prefix) {\n  --list-item-padding: var(#{$prefix}-item-padding);\n  --list-item-border-radius: var(#{$prefix}-item-border-radius);\n  --list-item-font-size: var(#{$prefix}-font-size);\n\n  :global(.dx-list-item) {\n    padding: var(--list-item-padding) !important;\n    border-radius: var(--list-item-border-radius) !important;\n    font-size: var(--list-item-font-size) !important;\n    :global(.dx-list-item-content) {\n      padding: 0 !important;\n    }\n  }\n}\n\n@mixin list-variant($prefix) {\n  --list-bg: var(#{$prefix}-bg);\n  --list-item-bg: var(#{$prefix}-item-bg);\n  --list-item-border: var(#{$prefix}-item-border);\n  --list-item-text-color: var(#{$prefix}-item-text-color);\n  --list-item-hover-bg: var(#{$prefix}-item-hover-bg);\n  --list-item-hover-border: var(#{$prefix}-item-hover-border);\n  --list-item-hover-text-color: var(#{$prefix}-item-hover-text-color);\n  --list-item-focused-bg: var(#{$prefix}-item-focused-bg);\n  --list-item-focused-border: var(#{$prefix}-item-focused-border);\n  --list-item-focused-text-color: var(#{$prefix}-item-focused-text-color);\n  --list-item-selected-bg: var(#{$prefix}-item-selected-bg);\n  --list-item-selected-border: var(#{$prefix}-item-selected-border);\n  --list-item-selected-text-color: var(#{$prefix}-item-selected-text-color);\n  --list-item-disabled-bg: var(#{$prefix}-item-disabled-bg);\n  --list-item-disabled-border: var(#{$prefix}-item-disabled-border);\n  --list-item-disabled-text-color: var(#{$prefix}-item-disabled-text-color);\n  --list-header-bg: var(#{$prefix}-header-bg);\n  --list-header-text: var(#{$prefix}-header-text);\n\n  background-color: var(--list-bg);\n  color: var(--list-item-text-color);\n\n  :global(.dx-list-item) {\n    background-color: var(--list-item-bg);\n    border: var(--list-item-border);\n    color: var(--list-item-text-color);\n\n    &:hover,\n    &:global(.dx-state-hover) {\n      background-color: var(--list-item-hover-bg) !important;\n      border: var(--list-item-hover-border) !important;\n      color: var(--list-item-hover-text-color) !important;\n    }\n\n    &:global(.dx-state-focused) {\n      background-color: var(--list-item-focused-bg) !important;\n      border: var(--list-item-focused-border) !important;\n      color: var(--list-item-focused-text-color) !important ;\n    }\n\n    &:has(:global(.dx-list-item-content) > [data-active=\"true\"]) {\n      background-color: var(--list-item-selected-bg) !important;\n      border: var(--list-item-selected-border) !important;\n      color: var(--list-item-selected-text-color) !important;\n      font-weight: 600;\n    }\n\n    &:global(.dx-state-disabled) {\n      background-color: var(--list-item-disabled-bg) !important;\n      border: var(--list-item-disabled-border) !important;\n      color: var(--list-item-disabled-text-color) !important;\n      cursor: not-allowed;\n    }\n  }\n\n  .listHeader {\n    background-color: var(--list-header-bg);\n    color: var(--list-header-text);\n  }\n}\n\n.list {\n  border-radius: var(--list-border-radius);\n  transition: all 0.2s ease-in-out;\n\n  /* Размеры */\n  &.sm {\n    @include list-size(\"--list-sm\");\n  }\n\n  &.md {\n    @include list-size(\"--list-md\");\n  }\n\n  &.lg {\n    @include list-size(\"--list-lg\");\n  }\n\n  /* Варианты */\n  &.main {\n    @include list-variant(\"--list-main\");\n  }\n\n  /* Элементы списка */\n  .listHeader {\n    padding: var(--list-md-item-padding);\n    font-weight: 600;\n    border-bottom: var(--list-border-width) solid var(--list-border-color);\n  }\n\n  /* Состояния */\n  &.bordered {\n    border: var(--list-border-width) solid var(--list-border-color);\n  }\n\n  &.shadow {\n    box-shadow: var(--list-shadow);\n  }\n\n  &.rounded {\n    border-radius: var(--list-border-radius);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": `IsrwafSAp4icb7BK9yvQ`,
	"sm": `LYyhGKd5BbyHB8VDV0xw`,
	"md": `pXAdIMko1OePWg6ayWeu`,
	"lg": `fXRv7ARnmw1CPPs4hgh9`,
	"main": `u2TPH5zXh56oLAyRD_gB`,
	"listHeader": `iK_RWjSR00HLSLt25T4F`,
	"bordered": `gHxAq8dkqqNVpSTelnxd`,
	"shadow": `LYVd0t95tKbjXQkq2SUc`,
	"rounded": `nJHesRfNJxAtapWLtohw`
};
export default ___CSS_LOADER_EXPORT___;
